export const translations = {
  de: {
    // General
    app_name: "BESTBUDDY",
    app_tagline: "Track. Travel. Triumph.",
    app_slogan: "Dein Alltags-Hero. Dein Reise-Partner. Dein BestBuddy.",
    mascot_name: "Nanouk",
    loading: "Lädt...",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    back: "Zurück",
    add: "Hinzufügen",
    edit: "Bearbeiten",
    today: "Heute",
    week: "Woche",
    all: "Alle",
    points: "Punkte",
    level: "Level",
    streak: "Streak",
    days: "Tage",
    
    // Auth
    login: "Anmelden",
    register: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    confirm_password: "Passwort bestätigen",
    name: "Name",
    logout: "Abmelden",
    welcome_back: "Willkommen zurück!",
    privacy_notice: "Mit der Nutzung stimmst du unseren Datenschutzrichtlinien zu.",
    
    // Navigation
    nav_dashboard: "Dashboard",
    nav_nutrition: "Ernährung",
    nav_sleep: "Schlaf",
    nav_fitness: "Fitness",
    nav_tasks: "Aufgaben",
    nav_travel: "Reisen",
    nav_achievements: "Erfolge",
    nav_coach: "Coach",
    nav_settings: "Einstellungen",
    
    // Dashboard
    good_day: "Guten Tag",
    daily_motivation: "Hey Buddy! Jeder Tag ist eine neue Chance, gemeinsam deine Ziele zu erreichen! 🐺",
    nanouk_greeting: "Wuff! Ich bin Nanouk, dein treuer BestBuddy. Lass uns heute gemeinsam durchstarten!",
    quick_actions: "Schnellaktionen",
    log_meal: "Mahlzeit loggen",
    track_sleep: "Schlaf tracken",
    start_workout: "Workout starten",
    ask_coach: "Coach fragen",
    overview: "Überblick",
    tasks_open: "offen",
    no_trip: "Keine Reise",
    planned: "geplant",
    active_trip: "Aktive Reise",
    collected: "gesammelt",
    
    // Nutrition
    nutrition_title: "Ernährung",
    nutrition_subtitle: "Tracke deine Mahlzeiten und Wasserzufuhr",
    add_meal: "Mahlzeit",
    calories: "Kalorien",
    protein: "Protein",
    carbs: "Kohlenhydrate",
    fat: "Fett",
    fiber: "Ballaststoffe",
    water_intake: "Wasserzufuhr",
    what_did_you_eat: "Was hast du gegessen?",
    portion_optional: "Portion (optional)",
    portion_hint: "z.B. große Portion, 200g, 1 Teller",
    meal_type: "Mahlzeit",
    breakfast: "Frühstück",
    lunch: "Mittagessen",
    dinner: "Abendessen",
    snack: "Snack",
    calculate_nutrients: "Nährwerte berechnen",
    analyzing: "Analysiere...",
    ai_calculates: "Die KI berechnet automatisch alle Nährwerte!",
    todays_meals: "Heutige Mahlzeiten",
    no_meals_yet: "Noch keine Mahlzeiten heute. Füge deine erste Mahlzeit hinzu!",
    no_entries: "Keine Einträge",
    nutrients_calculated: "Nährwerte berechnet!",
    meal_saved: "Mahlzeit gespeichert!",
    water_added: "Wasser getrunken!",
    
    // Sleep
    sleep_title: "Schlaf",
    sleep_subtitle: "Verfolge deine Schlafqualität und -dauer",
    log_sleep: "Schlaf loggen",
    fell_asleep: "Eingeschlafen",
    woke_up: "Aufgewacht",
    sleep_quality: "Schlafqualität",
    average: "Durchschnitt",
    quality: "Qualität",
    goal: "Ziel",
    sleep_duration: "Schlafdauer",
    last_entries: "Letzte Einträge",
    no_sleep_entries: "Noch keine Schlaf-Einträge. Logge deinen ersten Schlaf!",
    sleep_logged: "Schlaf eingetragen!",
    excellent: "Ausgezeichnet",
    good: "Gut",
    okay: "Okay",
    poor: "Schlecht",
    notes_optional: "Notizen (optional)",
    
    // Fitness
    fitness_title: "Fitness",
    fitness_subtitle: "Tracke deine Workouts und Aktivitäten",
    add_workout: "Workout",
    workout_type: "Workout-Typ",
    description: "Beschreibung",
    duration_min: "Dauer (Min)",
    calories_burned: "Kalorien verbrannt",
    strength: "Krafttraining",
    cardio: "Cardio",
    hiit: "HIIT",
    yoga: "Yoga",
    other: "Sonstiges",
    workouts: "Workouts",
    minutes: "Minuten",
    workout_distribution: "Workout-Verteilung",
    workout_types: "Workout-Typen",
    last_workouts: "Letzte Workouts",
    no_workouts_yet: "Noch keine Workouts. Zeit für dein erstes Training!",
    workout_logged: "Workout eingetragen!",
    this_week: "Diese Woche",
    
    // Tasks
    tasks_title: "Aufgaben",
    tasks_subtitle: "Organisiere deine Wellness-Ziele",
    add_task: "Aufgabe",
    task_title: "Titel",
    task_description: "Beschreibung (optional)",
    category: "Kategorie",
    priority: "Priorität",
    due_date: "Fällig am",
    general: "Allgemein",
    low: "Niedrig",
    medium: "Mittel",
    high: "Hoch",
    total: "Gesamt",
    open: "Offen",
    completed: "Erledigt",
    points_earned: "Punkte verdient",
    all_tasks: "Alle Aufgaben",
    open_tasks: "Offene Aufgaben",
    completed_tasks: "Erledigte Aufgaben",
    no_tasks: "Keine Aufgaben gefunden. Erstelle deine erste Aufgabe!",
    task_created: "Aufgabe erstellt!",
    task_completed: "Aufgabe erledigt!",
    task_deleted: "Aufgabe gelöscht",
    
    // Health Symptoms
    health_title: "Gesundheit",
    health_subtitle: "Tracke deine gesundheitlichen Feststellungen",
    log_symptom: "Symptom erfassen",
    add_symptom: "Symptom",
    symptom_category: "Kategorie",
    symptom_name: "Symptom",
    severity: "Stärke",
    cat_head: "Kopf",
    cat_stomach: "Magen/Darm",
    cat_energy: "Energie",
    cat_back: "Rücken",
    cat_mood: "Stimmung",
    cat_skin: "Haut",
    cat_respiratory: "Atemwege",
    cat_general: "Allgemein",
    sym_headache: "Kopfschmerzen",
    sym_migraine: "Migräne",
    sym_dizziness: "Schwindel",
    sym_stomach_ache: "Bauchschmerzen",
    sym_nausea: "Übelkeit",
    sym_bloating: "Blähungen",
    sym_heartburn: "Sodbrennen",
    sym_fatigue: "Müdigkeit",
    sym_exhaustion: "Erschöpfung",
    sym_low_energy: "Energielos",
    sym_back_pain: "Rückenschmerzen",
    sym_neck_pain: "Nackenschmerzen",
    sym_joint_pain: "Gelenkschmerzen",
    sym_anxiety: "Angst",
    sym_stress: "Stress",
    sym_sad: "Niedergeschlagen",
    sym_irritable: "Gereizt",
    sym_rash: "Hautausschlag",
    sym_itching: "Juckreiz",
    sym_cough: "Husten",
    sym_congestion: "Verstopfte Nase",
    sym_sore_throat: "Halsschmerzen",
    sym_other: "Sonstiges",
    symptom_logged: "Symptom erfasst!",
    todays_symptoms: "Heutige Feststellungen",
    no_symptoms_yet: "Keine Symptome heute erfasst.",
    symptom_deleted: "Symptom gelöscht",
    severity_mild: "Leicht",
    severity_moderate: "Mittel",
    severity_severe: "Stark",
    
    // Health Correlations
    correlations_title: "Korrelations-Analyse",
    correlations_subtitle: "Entdecke Zusammenhänge in deinen Daten",
    correlations_loading: "Analysiere Zusammenhänge...",
    correlations_no_data: "Noch nicht genug Daten für eine Analyse. Tracke weiter deine Symptome, Schlaf und Aktivitäten!",
    correlations_period: "Analysezeitraum",
    correlations_last_days: "Letzte {days} Tage",
    correlations_insights: "KI-Erkenntnisse",
    correlations_strong: "Starke Korrelation",
    correlations_moderate: "Moderate Korrelation",
    correlations_recommendation: "Empfehlung",
    correlations_data_points: "Datenpunkte",
    
    // Travel
    travel_title: "Reisen",
    travel_subtitle: "Verwalte deine Reisen und Jetlag",
    add_trip: "Reise",
    destination: "Ziel",
    departure: "Abreise",
    return: "Rückkehr",
    home_timezone: "Heimat-Zeitzone",
    dest_timezone: "Ziel-Zeitzone",
    notes: "Notizen",
    create_trip: "Reise erstellen",
    current_trip: "Aktive Reise",
    traveling: "Unterwegs",
    jetlag_tips: "Jetlag-Tipps",
    all_trips: "Alle Reisen",
    no_trips: "Noch keine Reisen geplant. Plane deine erste Reise!",
    trip_created: "Reise hinzugefügt!",
    trip_deleted: "Reise gelöscht",
    past: "Vergangen",
    active: "Aktiv",
    
    // Coach
    coach_title: "Nanouk Coach",
    coach_subtitle: "Dein persönlicher BestBuddy-Berater",
    daily_motivation_label: "Nanouks Tages-Motivation",
    ask_your_coach: "Frag Nanouk...",
    quick_questions: "Schnellfragen",
    improve_sleep: "Wie verbessere ich meinen Schlaf?",
    what_to_eat: "Was sollte ich heute essen?",
    workout_tip: "Gib mir einen schnellen Workout-Tipp",
    stay_fit_traveling: "Wie bleibe ich beim Reisen fit?",
    coach_greeting: "Wuff! Hey Buddy, ich bin Nanouk – dein treuer Sidekick! Gemeinsam schaffen wir alles. Was steht heute an?",
    
    // Achievements
    achievements_title: "Erfolge",
    achievements_subtitle: "Dein Fortschritt und deine Erfolge",
    all_achievements: "Alle Erfolge",
    leaderboard: "Rangliste",
    top_10: "Top 10 Rangliste",
    best_streak: "Bester Streak",
    unlocked: "Freigeschaltet",
    no_leaderboard: "Noch keine Ranglisten-Einträge. Sei der Erste!",
    points_to_next: "Noch {points} Punkte bis Level {level}",
    
    // Settings
    settings_title: "Einstellungen",
    settings_subtitle: "Verwalte dein Profil und deine Präferenzen",
    personal_data: "Persönliche Daten",
    age: "Alter",
    gender: "Geschlecht",
    male: "Männlich",
    female: "Weiblich",
    diverse: "Divers",
    weight_kg: "Gewicht (kg)",
    height_cm: "Größe (cm)",
    fitness_level: "Fitness-Level",
    beginner: "Anfänger",
    intermediate: "Fortgeschritten",
    advanced: "Experte",
    calculated_bmi: "Berechneter BMI",
    daily_goals: "Tagesziele",
    calories_kcal: "Kalorien (kcal)",
    water_ml: "Wasser (ml)",
    sleep_hours: "Schlaf (Stunden)",
    save_changes: "Änderungen speichern",
    saving: "Speichern...",
    appearance: "Darstellung",
    dark_mode: "Dunkler Modus",
    dark_mode_desc: "Wechsle zwischen Hell und Dunkel",
    language: "Sprache",
    language_desc: "Wähle deine Sprache",
    account: "Account",
    logout_desc: "Von deinem Account abmelden",
    profile_updated: "Profil aktualisiert!",
    
    // Voice
    voice_listening: "Höre zu...",
    voice_click_to_speak: "Klicken zum Sprechen",
    voice_not_supported: "Spracherkennung nicht unterstützt",
    
    // Errors
    error_loading: "Fehler beim Laden",
    error_saving: "Fehler beim Speichern",
    error_deleting: "Fehler beim Löschen",
    error_analyzing: "Fehler bei der Analyse",
    error_login: "Login fehlgeschlagen",
    error_register: "Registrierung fehlgeschlagen",
    error_passwords_mismatch: "Passwörter stimmen nicht überein",
    error_password_length: "Passwort muss mindestens 6 Zeichen haben",
  },
  
  en: {
    // General
    app_name: "BESTBUDDY",
    app_tagline: "Track. Travel. Triumph.",
    app_slogan: "Your Daily Hero. Your Travel Partner. Your BestBuddy.",
    mascot_name: "Nanouk",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    back: "Back",
    add: "Add",
    edit: "Edit",
    today: "Today",
    week: "Week",
    all: "All",
    points: "Points",
    level: "Level",
    streak: "Streak",
    days: "Days",
    
    // Auth
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    confirm_password: "Confirm Password",
    name: "Name",
    logout: "Logout",
    welcome_back: "Welcome back!",
    privacy_notice: "By using this app, you agree to our privacy policy.",
    
    // Navigation
    nav_dashboard: "Dashboard",
    nav_nutrition: "Nutrition",
    nav_sleep: "Sleep",
    nav_fitness: "Fitness",
    nav_tasks: "Tasks",
    nav_travel: "Travel",
    nav_achievements: "Achievements",
    nav_coach: "Coach",
    nav_settings: "Settings",
    
    // Dashboard
    good_day: "Good day",
    daily_motivation: "Hey Buddy! Every day is a new chance to reach our goals together! 🐺",
    nanouk_greeting: "Woof! I'm Nanouk, your loyal BestBuddy. Let's crush it today!",
    quick_actions: "Quick Actions",
    log_meal: "Log meal",
    track_sleep: "Track sleep",
    start_workout: "Start workout",
    ask_coach: "Ask coach",
    overview: "Overview",
    tasks_open: "open",
    no_trip: "No trip",
    planned: "planned",
    active_trip: "Active Trip",
    collected: "collected",
    
    // Nutrition
    nutrition_title: "Nutrition",
    nutrition_subtitle: "Track your meals and water intake",
    add_meal: "Meal",
    calories: "Calories",
    protein: "Protein",
    carbs: "Carbs",
    fat: "Fat",
    fiber: "Fiber",
    water_intake: "Water Intake",
    what_did_you_eat: "What did you eat?",
    portion_optional: "Portion (optional)",
    portion_hint: "e.g. large portion, 200g, 1 plate",
    meal_type: "Meal Type",
    breakfast: "Breakfast",
    lunch: "Lunch",
    dinner: "Dinner",
    snack: "Snack",
    calculate_nutrients: "Calculate Nutrients",
    analyzing: "Analyzing...",
    ai_calculates: "AI automatically calculates all nutritional values!",
    todays_meals: "Today's Meals",
    no_meals_yet: "No meals today yet. Add your first meal!",
    no_entries: "No entries",
    nutrients_calculated: "Nutrients calculated!",
    meal_saved: "Meal saved!",
    water_added: "Water added!",
    
    // Sleep
    sleep_title: "Sleep",
    sleep_subtitle: "Track your sleep quality and duration",
    log_sleep: "Log Sleep",
    fell_asleep: "Fell Asleep",
    woke_up: "Woke Up",
    sleep_quality: "Sleep Quality",
    average: "Average",
    quality: "Quality",
    goal: "Goal",
    sleep_duration: "Sleep Duration",
    last_entries: "Recent Entries",
    no_sleep_entries: "No sleep entries yet. Log your first sleep!",
    sleep_logged: "Sleep logged!",
    excellent: "Excellent",
    good: "Good",
    okay: "Okay",
    poor: "Poor",
    notes_optional: "Notes (optional)",
    
    // Fitness
    fitness_title: "Fitness",
    fitness_subtitle: "Track your workouts and activities",
    add_workout: "Workout",
    workout_type: "Workout Type",
    description: "Description",
    duration_min: "Duration (min)",
    calories_burned: "Calories Burned",
    strength: "Strength Training",
    cardio: "Cardio",
    hiit: "HIIT",
    yoga: "Yoga",
    other: "Other",
    workouts: "Workouts",
    minutes: "Minutes",
    workout_distribution: "Workout Distribution",
    workout_types: "Workout Types",
    last_workouts: "Recent Workouts",
    no_workouts_yet: "No workouts yet. Time for your first training!",
    workout_logged: "Workout logged!",
    this_week: "This Week",
    
    // Tasks
    tasks_title: "Tasks",
    tasks_subtitle: "Organize your wellness goals",
    add_task: "Task",
    task_title: "Title",
    task_description: "Description (optional)",
    category: "Category",
    priority: "Priority",
    due_date: "Due Date",
    general: "General",
    low: "Low",
    medium: "Medium",
    high: "High",
    total: "Total",
    open: "Open",
    completed: "Completed",
    points_earned: "Points earned",
    all_tasks: "All Tasks",
    open_tasks: "Open Tasks",
    completed_tasks: "Completed Tasks",
    no_tasks: "No tasks found. Create your first task!",
    task_created: "Task created!",
    task_completed: "Task completed!",
    task_deleted: "Task deleted",
    
    // Health Symptoms
    health_title: "Health",
    health_subtitle: "Track your health observations",
    log_symptom: "Log symptom",
    add_symptom: "Symptom",
    symptom_category: "Category",
    symptom_name: "Symptom",
    severity: "Severity",
    cat_head: "Head",
    cat_stomach: "Stomach",
    cat_energy: "Energy",
    cat_back: "Back",
    cat_mood: "Mood",
    cat_skin: "Skin",
    cat_respiratory: "Respiratory",
    cat_general: "General",
    sym_headache: "Headache",
    sym_migraine: "Migraine",
    sym_dizziness: "Dizziness",
    sym_stomach_ache: "Stomach ache",
    sym_nausea: "Nausea",
    sym_bloating: "Bloating",
    sym_heartburn: "Heartburn",
    sym_fatigue: "Fatigue",
    sym_exhaustion: "Exhaustion",
    sym_low_energy: "Low energy",
    sym_back_pain: "Back pain",
    sym_neck_pain: "Neck pain",
    sym_joint_pain: "Joint pain",
    sym_anxiety: "Anxiety",
    sym_stress: "Stress",
    sym_sad: "Feeling down",
    sym_irritable: "Irritable",
    sym_rash: "Rash",
    sym_itching: "Itching",
    sym_cough: "Cough",
    sym_congestion: "Congestion",
    sym_sore_throat: "Sore throat",
    sym_other: "Other",
    symptom_logged: "Symptom logged!",
    todays_symptoms: "Today's observations",
    no_symptoms_yet: "No symptoms logged today.",
    symptom_deleted: "Symptom deleted",
    severity_mild: "Mild",
    severity_moderate: "Moderate",
    severity_severe: "Severe",
    
    // Health Correlations
    correlations_title: "Correlation Analysis",
    correlations_subtitle: "Discover patterns in your data",
    correlations_loading: "Analyzing correlations...",
    correlations_no_data: "Not enough data for analysis yet. Keep tracking your symptoms, sleep and activities!",
    correlations_period: "Analysis period",
    correlations_last_days: "Last {days} days",
    correlations_insights: "AI Insights",
    correlations_strong: "Strong correlation",
    correlations_moderate: "Moderate correlation",
    correlations_recommendation: "Recommendation",
    correlations_data_points: "Data points",
    
    // Travel
    travel_title: "Travel",
    travel_subtitle: "Manage your trips and jetlag",
    add_trip: "Trip",
    destination: "Destination",
    departure: "Departure",
    return: "Return",
    home_timezone: "Home Timezone",
    dest_timezone: "Destination Timezone",
    notes: "Notes",
    create_trip: "Create Trip",
    current_trip: "Current Trip",
    traveling: "Traveling",
    jetlag_tips: "Jetlag Tips",
    all_trips: "All Trips",
    no_trips: "No trips planned yet. Plan your first trip!",
    trip_created: "Trip added!",
    trip_deleted: "Trip deleted",
    past: "Past",
    active: "Active",
    
    // Coach
    coach_title: "Nanouk Coach",
    coach_subtitle: "Your personal BestBuddy advisor",
    daily_motivation_label: "Nanouk's Daily Motivation",
    ask_your_coach: "Ask Nanouk...",
    quick_questions: "Quick Questions",
    improve_sleep: "How can I improve my sleep?",
    what_to_eat: "What should I eat today?",
    workout_tip: "Give me a quick workout tip",
    stay_fit_traveling: "How do I stay fit while traveling?",
    coach_greeting: "Woof! Hey Buddy, I'm Nanouk – your loyal sidekick! Together we can do anything. What's on your mind?",
    
    // Achievements
    achievements_title: "Achievements",
    achievements_subtitle: "Your progress and achievements",
    all_achievements: "All Achievements",
    leaderboard: "Leaderboard",
    top_10: "Top 10 Leaderboard",
    best_streak: "Best Streak",
    unlocked: "Unlocked",
    no_leaderboard: "No leaderboard entries yet. Be the first!",
    points_to_next: "{points} more points to Level {level}",
    
    // Settings
    settings_title: "Settings",
    settings_subtitle: "Manage your profile and preferences",
    personal_data: "Personal Data",
    age: "Age",
    gender: "Gender",
    male: "Male",
    female: "Female",
    diverse: "Diverse",
    weight_kg: "Weight (kg)",
    height_cm: "Height (cm)",
    fitness_level: "Fitness Level",
    beginner: "Beginner",
    intermediate: "Intermediate",
    advanced: "Advanced",
    calculated_bmi: "Calculated BMI",
    daily_goals: "Daily Goals",
    calories_kcal: "Calories (kcal)",
    water_ml: "Water (ml)",
    sleep_hours: "Sleep (hours)",
    save_changes: "Save Changes",
    saving: "Saving...",
    appearance: "Appearance",
    dark_mode: "Dark Mode",
    dark_mode_desc: "Switch between light and dark",
    language: "Language",
    language_desc: "Choose your language",
    account: "Account",
    logout_desc: "Sign out of your account",
    profile_updated: "Profile updated!",
    
    // Voice
    voice_listening: "Listening...",
    voice_click_to_speak: "Click to speak",
    voice_not_supported: "Speech recognition not supported",
    
    // Errors
    error_loading: "Error loading data",
    error_saving: "Error saving",
    error_deleting: "Error deleting",
    error_analyzing: "Error analyzing",
    error_login: "Login failed",
    error_register: "Registration failed",
    error_passwords_mismatch: "Passwords do not match",
    error_password_length: "Password must be at least 6 characters",
  }
};
